export default __webpack_public_path__ + "static/media/next2.22bb277e.png";